import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from 'src/app/shared/config';
import { suggestionAddress } from './test-data-shared';
@Injectable({
  providedIn: 'root',
})
export class SmartyStreetsService {

 private embeddedKey: string = config.smartyKey;
 private apiUrl = 'https://us-autocomplete-pro.api.smarty.com/lookup';
 private countyApiUrl = 'https://us-street.api.smarty.com/street-address';

 constructor(private http: HttpClient) { }
 autocompleteAddress(query: string, requiredState: string, stateRestrciton: boolean, selected: string) {
   const headers = new HttpHeaders();
    let params;

    if(stateRestrciton && requiredState != '' && selected && selected !=''){
      params = new HttpParams()
      .set('include_only_states', requiredState)
      .set('key', this.embeddedKey)
      .set('search', query)
      .set('selected', selected)
    } else if(stateRestrciton && requiredState != ''){
      params = new HttpParams()
      .set('include_only_states', requiredState)
      .set('key', this.embeddedKey)
      .set('search', query)
    } else if(selected && selected !=''){
      params = new HttpParams()
      .set('key', this.embeddedKey)
      .set('search', query)
      .set('selected', selected)
    } else{
      params = new HttpParams()
        .set('key', this.embeddedKey)
        .set('search', query);
    }

   try {
    if(config.validateAddresses)
      return this.http.get(this.apiUrl,{ params, headers }).pipe().toPromise();
    else{
      const address = { ...suggestionAddress };
       if(requiredState!= undefined && requiredState!='') {
        address.suggestions = address.suggestions.filter(
              item =>
                (requiredState!='' && item.state.toLowerCase() === requiredState.toLowerCase() ) 
            );
          }
          address.suggestions = address.suggestions.filter(
              item =>
            item.street_line.toLowerCase().includes(query.toLocaleLowerCase()) 
            );
       
            return Promise.resolve(address);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
 }


  getCountyByAddress(street: string, city: string, state: string) {
    const params = new HttpParams()
    .set('key', this.embeddedKey)
    // .set('license', 'us-core-cloud')
    .set('street', street)
    .set('city', city)
    .set('state', state);
    return this.http.get(this.countyApiUrl,{ params });
 }
 

}
